import { render, staticRenderFns } from "./auth-control.vue?vue&type=template&id=2e67b500&scoped=true"
import script from "./auth-control.vue?vue&type=script&lang=js"
export * from "./auth-control.vue?vue&type=script&lang=js"
import style0 from "./auth-control.vue?vue&type=style&index=0&id=2e67b500&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e67b500",
  null
  
)

export default component.exports